<script>
    import { format } from 'date-fns';

    import main from '../state/main';
    import modals from '../state/modals';
    import user from '../state/user';
    import events from '../state/events';

    let showForm = true;
    let formError = null;

    let canEditClientForm = true;
    let canEditEmail = true;
    let requestLogin = false;

    let clientForm = {
        email: '',
        name: '',
        phone: ''
    };

    let withCredits = false;

    let users = {};
    let selectedUsers = [];
    $: users = getUsers(selectedUsers);

    /**
     * Converts list of user ids to an object
     */
    function getUsers(selectedUsers) {
        let out = {};

        for (let clnId of selectedUsers) {
            out[clnId] = true;
        }

        return out;
    }

    /**
     * Users clicked on one of the users in the list (toggle selection)
     */
    function toggleUser(clnId) {
        let newList = selectedUsers;

        if (users[clnId]) {
            if (newList.length == 1) return;

            // Remove the user from list
            newList.splice(newList.indexOf(clnId), 1);
        } else {
            // Add user to list
            newList.unshift(clnId);

            // Limit to last 2 users
            newList = newList.slice(0, 2);
        }

        selectedUsers = newList;
    }

    // Event shorthand
    let event = null;
    $: event = $modals.event_item;

    let lastState = null;
    $: onChange($modals.reservation_opened);

    function onChange(state) {
        if (lastState === state) return;
        lastState = state;

        // Reset form
        showForm = true;
        formError = null;
        canEditClientForm = true;
        canEditEmail = true;
        requestLogin = false;
        clientForm.email = clientForm.name = clientForm.phone = '';
        withCredits = $modals.reservation_withCredits;
        users = {};
        selectedUsers = [];

        if (currentUser) onUserLoaded(currentUser);
    }

    let currentUser;
    $: currentUser = $user;

    $: $user && onUserLoaded($user);
    function onUserLoaded(user) {
        // Loaded for signed-in user
        if (user.cln_email) {
            clientForm.email = user.cln_email;
            canEditEmail = false;
            requestLogin = false;
        } else {
            requestLogin = !!user.hasPassword;
        }

        // Update form
        clientForm.name = user.cln_name;
        clientForm.id = user.cln_id;

        // Update list of selected users
        selectedUsers = [user.cln_id];
        users = getUsers(selectedUsers);

        canEditClientForm = false;
    }

    function closeModal(e) {
        modals.toggleReservationModal(false);
    }

    async function onEmailChange() {
        canEditClientForm = false;

        let res = await user.getByEmail(clientForm.email);

        // User not found, ignore
        if (!res) {
            canEditClientForm = true;
            requestLogin = false;
            return;
        }

        onUserLoaded(res);
    }

    function onLogin() {
        modals.toggleSignModal(true);
    }

    async function onReserve() {
        // Not signed in
        if (!$user) {
            // Check if user exists for the email (and has password)
            let resCheck = await user.getByEmail(clientForm.email);
            if (resCheck && resCheck.hasPassword) {
                onUserLoaded(resCheck);
                return;
            } else {
                requestLogin = false;
            }
        }

        // Get checked users
        let clnIds = [];
        for (let clnId in users) {
            if (users[clnId]) clnIds.push(clnId);
        }

        // Cannot edit form
        canEditClientForm = false;

        // Create reservation
        let res = await events.reserve(event, clientForm, withCredits, clnIds);

        // Can edit form again
        canEditClientForm = true;

        // Hide form
        showForm = false;

        // Error ?!
        formError = null;
        if (!res || !res.status) {
            formError = {
                message: res ? res.message : null
            };
            return;
        }

        // Mark as reserved for current user
        if (res && currentUser) {
            event.res_id = res.id;
            event.res_code = res.code;
        }
    }

    // TODO: Move these ...

    // Format specified date
    function formatDate(date) {
        return format(date, 'D. M. YYYY');
    }

    function formatTime(date) {
        return format(date, 'H:mm');
    }

    function formatPhone(phone) {
        let out = [];

        if (!phone || typeof phone !== 'string' || !phone.length) {
            return null;
        }

        // Remove formatting
        phone = phone.replace(/[^0-9+]/g, '');

        while (phone.length > 0) {
            // Consume up to 3 numbers from the end
            phone = phone.replace(/.{1,3}$/, part => {
                out.unshift(part);
                return '';
            });
        }

        return out.join(' ').replace('+ ', '+');
    }

    function cleanupPhone() {
        let phone = clientForm.phone.replace(/[^0-9+]/, '');

        // TODO: More cleanup

        clientForm.phone = formatPhone(phone);
    }

    function creditsText(count) {
        if (count == 1) return '1 kredit';

        if (count >= 2 && count <= 4) {
            return `${count} kredity`;
        }

        return `${count} kreditů`;
    }
</script>

<style>
    .group {
        display: inline-flex;
        border-radius: 20px;
        overflow: hidden;
        margin: 0 10px 10px 0;
    }

    .group .caption, .group .text {
        padding: 2px 8px;
    }

    .group .caption {
        font-weight: 500;
        background: #e6e6e6;
    }

    .group .text {
        background: white;
        /* flex: 1; */
    }

    .message-body hr {
        background-color: #bbb;
    }

    .user {
        display: flex;
        cursor: pointer;
        flex-direction: row;
        position: relative;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        padding: 8px 12px 8px 26px;
        background: white;
    }

    .user .item {
        white-space: nowrap;
    }

    .user .item:first-child {
        flex: 1;
    }

    .user .item:not(:first-child) {
        padding-left: 10px;
    }

    .user::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 5px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 1px solid #d6d6d6;
        margin-top: -8px;
        line-height: 14px;
        font-family: "Font Awesome 5 Pro";
        font-size: 10px;
        text-align: center;
        background: #efefef;
        color: white;
    }

    .user._checked::before {
        content: "\f00c";
        border-color: dodgerblue;
        background: dodgerblue;
    }

    .user:not(:last-child) {
        margin-bottom: 12px;
    }

    .notification._signInRequired {
        display: flex;
        flex-direction: row;
        padding: 0;
        justify-content: space-between;
        align-items: center;
        padding-left: 15px;
    }

    .notification._signInRequired .button {
        height: 60px;
        border-radius: 0 4px 4px 0;
    }

    .modal-card-foot small {
        flex: 1;
        text-align: right;
    }
</style>

{#if $modals.reservation_opened && event}
    <div class="modal is-active">
        <div class="modal-background" on:click={closeModal}></div>
        <form class="modal-card" on:submit|preventDefault={onReserve}>
            <header class="modal-card-head">
                <div class="modal-card-title">
                    Shrnutí & platba lekce
                </div>
                <button class="delete" aria-label="Zavřít" on:click={closeModal}></button>
            </header>
            <section class="modal-card-body">
                <article class="message">
                    <div class="message-header">
                        O lekci
                    </div>
                    <div class="message-body">
                        <div>
                            <div class="group">
                                <span class="caption">Název lekce</span>
                                <span class="text">{event.evn_title}</span>
                            </div>
                        </div>

                        <div>
                            <div class="group">
                                <span class="caption">Datum lekce</span>
                                <span class="text">{formatDate(event.evr_from)}</span>
                            </div>
                            <div class="group">
                                <span class="caption">Délka lekce</span>
                                <span class="text">{event.length} minut</span>
                            </div>
                        </div>

                        <div>
                            <div class="group">
                                <span class="caption">Začátek lekce</span>
                                <span class="text">{formatTime(event.evr_from)}</span>
                            </div>
                            <div class="group">
                                <span class="caption">Konec lekce</span>
                                <span class="text">{formatTime(event.evr_to)}</span>
                            </div>
                        </div>

                        {#if event.ven_id}
                            <hr>

                            <div>
                                <div class="group">
                                    <span class="caption">Místo konání</span>
                                    <span class="text">{event.ven_caption}</span>
                                </div>

                                <div class="group">
                                    <span class="caption">Adresa</span>
                                    <span class="text">{event.ven_address}</span>
                                </div>

                                {#if event.ven_notice}
                                    <div class="notification is-warning"><strong>Upozornění:</strong> {event.ven_notice}</div>
                                {/if}
                            </div>
                        {/if}
                    </div>
                </article>

                <article class="message">
                    <div class="message-header">
                        Kontaktní informace
                    </div>
                    <div class="message-body">
                        {#if showForm}
                            {#if !$user}
                                <div class="field">
                                    <!-- svelte-ignore a11y-label-has-associated-control -->
                                    <label class="label">E-mail</label>
                                    <div class="control">
                                        <input class="input" type="email" name="email" placeholder="Váš email"
                                            bind:value={clientForm.email}
                                            on:change={onEmailChange}
                                            readonly={!canEditEmail}
                                            required>
                                    </div>
                                </div>

                                {#if !requestLogin}
                                    <div class="field">
                                        <!-- svelte-ignore a11y-label-has-associated-control -->
                                        <label class="label">Jméno</label>
                                        <div class="control">
                                            <input class="input" type="text" name="fname" placeholder="Vaše jméno"
                                                bind:value={clientForm.name}
                                                readonly={!canEditClientForm}
                                                required>
                                        </div>
                                    </div>

                                    <div class="field">
                                        <!-- svelte-ignore a11y-label-has-associated-control -->
                                        <label class="label">Telefon</label>
                                        <div class="control">
                                            <input class="input" type="text" name="phone" placeholder="Vaše telefonní číslo"
                                                bind:value={clientForm.phone}
                                                readonly={!canEditClientForm}
                                                on:change={cleanupPhone}
                                                maxlength="16"
                                                required>
                                        </div>
                                    </div>
                                {:else}
                                    <div class="notification is-info _signInRequired">
                                        Na tento email již existuje účet.<br>
                                        Pro pokračování se přihlašte.
                                        <button type="button" class="button is-primary" on:click={onLogin}>Přihlásit se</button>
                                    </div>
                                {/if}
                            {:else}
                                {#if $user.subs && $user.subs.length}
                                    <div class="notification is-info">
                                        Vyberte účastníky lekce:
                                    </div>

                                    <div class="user" class:_checked={!!users[$user.cln_id]} on:click={() => toggleUser($user.cln_id)}>
                                        <span class="item">{$user.cln_name}</span>
                                        {#if formatPhone($user.cln_phone)}
                                            <span class="item"><i class="fal fa-phone"></i> {formatPhone($user.cln_phone)}</span>
                                        {/if}
                                    </div>

                                    {#each $user.subs as sub}
                                        <div class="user" class:_checked={!!users[sub.cln_id]} on:click={() => toggleUser(sub.cln_id)}>
                                            <span class="item">{sub.cln_name}</span>
                                            {#if formatPhone(sub.cln_phone)}
                                                <span class="item"><i class="fal fa-phone"></i> {formatPhone(sub.cln_phone)}</span>
                                            {/if}
                                        </div>
                                    {/each}
                                {:else}
                                    <div class="notification is-info">
                                        Jste přihlášeni! Rezervace bude na jméno <em>{$user.cln_name}</em>.
                                    </div>
                                {/if}
                            {/if}
                        {:else if formError}
                            <div class="notification is-danger">
                                {#if formError.message}
                                    {formError.message}
                                {:else}
                                    Při rezervování došlo k chybě!
                                {/if}
                            </div>
                        {:else}
                            <div class="notification is-success">
                                Rezervace byla vytvořena!<br>

                                {#if withCredits}
                                    Pro platbu byly využity kredity z vašeho účtu, proto není nutné nic platit.<br>
                                    Byl vám odeslán potvrzovací email.
                                {:else}
                                    Ale aby byla platná je nutné ji zaplatit.<br>
                                    V emailu naleznete informace k platbě.
                                {/if}
                            </div>
                        {/if}
                    </div>
                </article>

                <article class="message">
                    <div class="message-header">
                        Platba
                    </div>
                    <div class="message-body">
                        {#if $modals.reservation_withCredits}
                            <div class="group">
                                <span class="caption">Celková cena</span>
                                <span class="text">{creditsText(Math.max(selectedUsers.length, 1) * event.evt_credits)}</span>
                            </div>
                        {:else}
                            <div class="group">
                                <span class="caption">Celková cena</span>
                                <span class="text">{Math.max(selectedUsers.length, 1) * event.evt_price} Kč</span>
                            </div>
                        {/if}
                    </div>
                </article>
            </section>

            <footer class="modal-card-foot">
                <button class="button is-primary" disabled={!showForm || requestLogin}>Zaplatit</button>
                <small>Rezervací souhlasíte s <a href="{$main.baseWeb}/vop" target="_blank">obchodními podmínkami</a></small>
            </footer>
        </form>
    </div>
{/if}